import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import routes from "routes";
import logo from "assets/images/brand/rpg-logo.png";
import { useMaterialUIController, setMiniSidenav } from "context";
import { useAuth } from "pages/Auth/AuthContext";
import LoadingScreen from "./LoadingScreen";
import { DEFAULT_ROUTES } from "components/common/constant";

export default function AdminLayout() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const { role, isAuthenticated, loading } = useAuth();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, []);

  const defaultRoute = DEFAULT_ROUTES[role] || "/admin/dashboard";

  if (loading) {
    return <LoadingScreen />;
  }

  // Expand sidenav on hover
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const getAdminRoutes = (allRoutes) =>
    allRoutes.flatMap((route) => {
      if (route.collapse) {
        return getAdminRoutes(route.collapse);
      }

      if (route.layout === "/technician" && route.route) {
        const hasAccess = !route.roles || route.roles.includes(role);

        return (
          <Route
            key={route.key}
            path={route.route.replace("/", "")}
            element={
              isAuthenticated ? (
                hasAccess ? (
                  route.component
                ) : (
                  <Navigate to="dashboard" replace />
                )
              ) : (
                <Navigate to="/auth/sign-in" replace />
              )
            }
          />
        );
      }

      return [];
    });

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return (
    <>
      <Sidenav
        color={sidenavColor}
        brand={logo}
        routes={routes}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
      />

      <Configurator />

      <div className="main-content">
        <Routes>
          {getAdminRoutes(routes)}
          <Route
            path="*"
            element={<Navigate to={defaultRoute} replace />} //default route for now
          />
        </Routes>
      </div>
    </>
  );
}
